import { AuditActionType, type EntityHistoryItem } from "@/api/admin/auditLog";

import type { HistoryTitleResolver } from "./getHistoryTitle";

const MENU_ENTITY_TYPES = new Set(["Menu Dish", "Menu Category", "Menu"]);

export const CASHBACK_ITEM_EXCLUSION_ENTITY_TYPE = "Cashback Item Exclusion";

export const isMenuEntityCreateLog = (item: EntityHistoryItem): boolean =>
  item.action === AuditActionType.CREATE &&
  MENU_ENTITY_TYPES.has(item.entityType);

export const isCashbackItemExclusionLog = (item: EntityHistoryItem): boolean =>
  item.entityType === CASHBACK_ITEM_EXCLUSION_ENTITY_TYPE;

export const isPosIntegrationLog = (item: EntityHistoryItem): boolean =>
  item.entityType === "POS Integration";

export const resolveBranchMenuHistoryTitle: HistoryTitleResolver = item => {
  if (item.entityType !== CASHBACK_ITEM_EXCLUSION_ENTITY_TYPE) {
    return undefined;
  }

  if (item.action === AuditActionType.CREATE) {
    return `${item.entityName} added to excluded items`;
  }

  if (item.action === AuditActionType.DELETE) {
    return `${item.entityName} removed from excluded items`;
  }

  return undefined;
};
